import { render, staticRenderFns } from "./VehicleTypeList.vue?vue&type=template&id=8093883c&scoped=true"
import script from "./VehicleTypeList.vue?vue&type=script&lang=js"
export * from "./VehicleTypeList.vue?vue&type=script&lang=js"
import style0 from "./VehicleTypeList.vue?vue&type=style&index=0&id=8093883c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8093883c",
  null
  
)

export default component.exports